var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureDocMobileBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5C17.1 4.1 17.9 4.3 18.3 4.9C18.7 5.5 18.5 6.3 17.9 6.7L11.8 12L17.9 17.3C18.5 17.7 18.7 18.5 18.3 19.1C17.9 19.7 17.1 19.9 16.5 19.5L9.5 13.5C9.2 13.2 9 12.8 9 12.4V11.6C9 11.2 9.2 10.8 9.5 10.5L16.5 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureDocMobileBackIcon);
export default __webpack_public_path__ + "static/media/secure-doc-mobile-back-icon.ad88867649f77ba224236c3e5e22c340.svg";
export { ForwardRef as ReactComponent };